// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"7a0f6d67","238":"097aa2af","318":"c7f62c4f","551":"6618b584","629":"046b0b0f","842":"8abf7425"}[chunkId] + ".chunk.js";
};